<!-- View Selected Employees Modal-->
<ui-dialog [header]="'Employees Matched'" [open]="showEmployeesMatched" (closing)="hideEmployeesMatched()">
    <p>{{ 'dashboard.employeeFilterPreview' | translate: { count: employerFilterPreviewPagination.total } }}</p>

    <app-pagination
        *ngIf="employerFilterPreviewPagination.total >= employerFilterPreviewPagination.perPage"
        [total]="employerFilterPreviewPagination.total"
        [limit]="employerFilterPreviewPagination.perPage"
        [current]="employerFilterPreviewPagination.page"
        (pageChange)="changePage($event)"
    ></app-pagination>

    <app-employee-list
        style="height: 200px; overflow: auto"
        [employees]="employeesToPreview"
        [showEditButton]="false"
        [showTitle]="false"
    >
    </app-employee-list>

    <ui-dialog-footer>
        <ui-button type="primary" (click)="hideEmployeesMatched()">{{ 'dashboard.done' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog [header]="'Test Announcement Sent'" [open]="testAnnouncementSent" (closing)="closeTestAnnouncementModal()">
    <p>{{ 'dashboard.viewTestAnnouncement' | translate }}</p>

    <ui-dialog-footer>
        <ui-button (click)="closeTestAnnouncementModal()" type="outline">{{ 'dashboard.close' | translate }}</ui-button>

        <ui-button [submit]="true" (click)="openDashboardInNewTab()" type="primary">{{
            'dashboard.previewInNewTab' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [back]="true" title="{{ 'dashboard.createAnnouncement' | translate }}"></app-header>

    <div class="app-grid">
        <div class="columns-9">
            <ui-card>
                <div class="columns-12">
                    <app-form-announcement #announcementForm></app-form-announcement>
                </div>

                <div class="columns-12">
                    <mat-label>{{ 'dashboard.sendTo' | translate }}</mat-label>
                    <mat-radio-group
                        class="vertical"
                        aria-label="Send To"
                        name="sendToAll"
                        [(ngModel)]="sendToAll"
                        #sendTo="ngModel"
                        required
                    >
                        <mat-radio-button [value]="true"> {{ 'dashboard.allEmployees' | translate }} </mat-radio-button>
                        <mat-radio-button [value]="false">
                            {{ 'dashboard.selectedGroupOfEmployees' | translate }}
                        </mat-radio-button>
                    </mat-radio-group>

                    <mat-error *ngIf="sendTo.invalid">{{ sendTo.errors | formErrors }}</mat-error>

                    <div *ngIf="sendToAll === false" class="margin-top-2">
                        <app-employee-criteria-selection
                            #employeeCriteriaSelection
                            [employeeFilter]="employeeFilter"
                            (selectionChange)="onSelectionChange()"
                        ></app-employee-criteria-selection>
                    </div>
                </div>

                <ui-button
                    *ngIf="sendToAll === false"
                    type="link"
                    class="margin-top-1 view-selected-employees-button"
                    (click)="showPreviewOfSelectedEmployees()"
                >
                    {{
                        'dashboard.viewMatchedEmployees'
                            | translate
                                : {
                                      count:
                                          employerFilterPreviewPagination.total > 0
                                              ? employerFilterPreviewPagination.total
                                              : '',
                                  }
                    }}
                </ui-button>
            </ui-card>
            <div class="flex justify-space-between">
                <ui-button type="link" (click)="sendTestAnnouncement(announcementForm)">
                    {{ 'dashboard.sendTestAnnouncement' | translate }}
                </ui-button>
                <div>
                    <ui-button type="ghost" (click)="onCancel()">{{ 'dashboard.cancel' | translate }}</ui-button>
                    <ui-button class="padding-left-1" type="primary" (click)="onSave(announcementForm)">
                        {{ 'dashboard.send' | translate }}
                    </ui-button>
                </div>
            </div>
        </div>

        <div class="columns-3">
            <ui-card class="announcements-info-card">
                <app-segment-header title="{{ 'dashboard.companyAnnouncements' | translate }}"></app-segment-header>
                <p>{{ 'dashboard.companyAnnouncementInformation' | translate }}</p>
            </ui-card>
        </div>
    </div>
</div>
